import React from "react";
import { cn } from "../../lib/utils";

export function Skeleton({ className, testId }) {
  return (
    <div
      data-testid={testId || "skeleton"}
      className={cn("animate-pulse rounded bg-slate-200/70", className)}
    />
  );
}

export function SkeletonRow({ cells = 4, className }) {
  return (
    <div className={cn("flex gap-4", className)}>
      {Array.from({ length: cells }).map((_, i) => (
        <Skeleton key={i} className="h-4 flex-1" />
      ))}
    </div>
  );
}

export function SkeletonTable({ rows = 6, cols = 5 }) {
  return (
    <div className="space-y-3" data-testid="skeleton-table">
      <SkeletonRow cells={cols} />
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} cells={cols} />
      ))}
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="rounded border border-slate-200 bg-white p-6 space-y-3" data-testid="skeleton-card">
      <Skeleton className="h-5 w-40" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="h-4 w-2/3" />
    </div>
  );
}
